import {CanDeactivateFn} from '@angular/router';

/**
 * Components guarded by {@link unsavedChangesGuard} expose this method. It runs
 * on ANY navigation away from the route — the visual back button, the browser's
 * back/forward buttons, and any in-app router navigation — and returns whether
 * leaving is allowed (typically after confirming discard of unsaved changes).
 */
export interface CanComponentDeactivate {
  canDeactivate: () => Promise<boolean> | boolean;
}

export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component) =>
  component?.canDeactivate ? component.canDeactivate() : true;
